
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/giftCard/defList",
      function () {
        return require("private-next-pages/giftCard/defList.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/giftCard/defList"])
      });
    }
  